import { HiMinus } from "react-icons/hi";
import { RxPlus } from "react-icons/rx";

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border border-[#0000001A] rounded-2xl bg-[#F3F3F3] overflow-hidden  ">
      <div
        onClick={onClick}
        className="flex items-center justify-between gap-1 w-full lg:p-5 md:p-4 p-3   md:text-[1.125rem] text-base font-semibold text-black font-inter text-left"
      >
        <span>{question}</span>

        <button className="md:w-5 w-4 md:h-5 h-4 relative mr-1">
          <span
            className={`absolute inset-0 transition-all duration-300 ease-in-out ${
              isOpen ? "opacity-0 scale-90" : "opacity-100 scale-100"
            }`}
          >
            <RxPlus className="w-5 h-5" />
          </span>
          <span
            className={`absolute inset-0 transition-all duration-300 ease-in-out ${
              isOpen ? "opacity-100 scale-100" : "opacity-0 scale-90"
            }`}
          >
            <HiMinus className="w-5 h-5" />
          </span>
        </button>
      </div>

      <div
        className={` lg:px-5 md:px-4 px-3 overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen
            ? "max-h-40 opacity-100 lg:pb-5 md:pb-4 pb-3"
            : "max-h-0 opacity-0"
        }`}
      >
        <p className="md:text-[15px] text-[13px] text-[#00000099]">{answer}</p>
      </div>
    </div>
  );
};

export default FAQItem;
